import { render, staticRenderFns } from "./DebugAlert.vue?vue&type=template&id=cf474614&scoped=true"
var script = {}
import style0 from "./DebugAlert.vue?vue&type=style&index=0&id=cf474614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf474614",
  null
  
)

export default component.exports